<template>
  <div class="charts" ref="chart" :auto-resize="true"></div>
</template>

<script>
export default {
  name: "TempRingChart",
  props: ['data'],
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      console.log("initCharts")
      let myChart = this.$echarts.init(this.$refs.chart, 'shine')
      let _this = this
      console.log(_this.data)
      const option = {
        title: {
          show: true,
          text: _this.data.cbParameter.tempwarningValue + "℃",
          textStyle: {
            color: '#465074',
            fontSize: 16,
            fontFamily: 'Century Gothic',
            fontWeight: 'normal',
          },
          subtext: '阀值',
          subtextStyle: {
            color: '#909090',
            fontSize: 10,
            fontFamily: 'Microsoft YaHei',
            fontWeight: 'normal',
          },
          itemGap: 2, // 主副标题距离
          left: 'center',
          top: 'center',
        },
        tooltip: {
          formatter: function(data) {
            return (
              data.seriesName +
              '<br/>' +
              data.name +
              ' : ' +
              data.value.toFixed(0) +
              '%'
            );
          },
        },
        angleAxis: {
          max: _this.data.cbParameter.tempwarningValue,
          startAngle: 90,
          show: false,  // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        radiusAxis: {
          type: 'category',
          z: 1,
          show: false,  // 隐藏刻度线
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        polar: {
          center: ['50%', '50%'],
          radius: ['62%', '68%'],
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: _this.data.temperature,
              },
            ],
            coordinateSystem: 'polar',
            name: '温度',
            roundCap: true,
            stack: 'a',
            zlevel: 2,
          }, {
            type: 'bar',
            data: [
              {
                value: _this.data.cbParameter.tempwarningValue,
              },
            ],
            color: '#EBEAF9',
            coordinateSystem: 'polar',
            name: '温度',
            roundCap: true,
            stack: 'a',
          }
        ],
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => {
        myChart.resize();
      })
    }
  }
}
</script>

<style scoped>
.charts {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/TempRingChart.vue